/**
 * İngilizce ve Türkçe statik sayfa yollarının eşleşmesi.
 *
 * Tek doğruluk kaynağıdır. React tarafı (Navbar, Footer, dil değiştirici) ve
 * scripts/prerender.mjs aynı listeyi okur; prerender bu dosyayı esbuild ile
 * bellekte JS'e çevirip yüklediği için dosyanın hiçbir importu olmamalıdır
 * (aynı desen: lib/privacyContent.ts).
 *
 * Her çift aynı içeriğin iki dildeki kanonik adresidir. hreflang etiketleri,
 * menü linkleri ve dil değiştirici bu listeden üretilir; üçünün birbirinden
 * ayrılma ihtimali böylece ortadan kalkar.
 *
 * Dinamik rotalar (hizmet ve blog detayları) burada değildir: onların
 * karşılıkları Firestore'daki slug_en / slug_tr alanlarından gelir.
 */

export type StaticPathPair = { en: string; tr: string };

export const STATIC_PATH_PAIRS: StaticPathPair[] = [
  { en: "/", tr: "/tr" },
  { en: "/about", tr: "/tr/hakkimizda" },
  { en: "/services", tr: "/tr/hizmetler" },
  { en: "/portfolio", tr: "/tr/portfolyo" },
  { en: "/news", tr: "/tr/haberler" },
  { en: "/contact", tr: "/tr/iletisim" },
  { en: "/privacy", tr: "/tr/gizlilik" },
];

/** Sondaki eğik çizgiyi atar; kök yol ("/") olduğu gibi kalır. */
const normalize = (pathname: string): string =>
  pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;

/**
 * Verilen yolun hedef dildeki karşılığını döndürür.
 * Eşleşme yoksa (dinamik rotalar, /admin, /p/... gibi) null döner;
 * çağıran taraf bu durumda yönlendirme yapmamalıdır.
 */
export function localizedPath(pathname: string, target: "en" | "tr"): string | null {
  const clean = normalize(pathname);
  const pair = STATIC_PATH_PAIRS.find((p) => p.en === clean || p.tr === clean);
  if (!pair) return null;
  return target === "tr" ? pair.tr : pair.en;
}

/**
 * Menü ve footer linkleri için: İngilizce yolu aktif dile çevirir.
 * Türkçe karşılığı olmayan bir yol verilirse İngilizce yol korunur, böylece
 * link hiçbir zaman kırılmaz. "de" için ayrı URL yapısı yoktur; Almanca
 * içerik İngilizce adreslerde render edilir.
 */
export function navPath(enPath: string, lang: string): string {
  if (lang !== "tr") return enPath;
  return localizedPath(enPath, "tr") ?? enPath;
}
